// extracted by mini-css-extract-plugin
module.exports =  {"layout":"_93444fe79c--layout--TjvSZ","spinner":"_93444fe79c--spinner--uIpxO","container":"_93444fe79c--container--O_TQ1","error":"_93444fe79c--error--bfnyQ"};